import { render } from "./CadastrarServico.vue?vue&type=template&id=040b710d&scoped=true"
import script from "./CadastrarServico.vue?vue&type=script&lang=js"
export * from "./CadastrarServico.vue?vue&type=script&lang=js"

import "./CadastrarServico.vue?vue&type=style&index=0&id=040b710d&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040b710d"]])

export default __exports__